import * as React from 'react';
import {
  type DateRange,
  type Matcher,
  type PropsBase,
  type PropsRange,
} from 'react-day-picker';
import {Calendar} from '../../../calendar';

type DateRangeCalendarProps = Omit<
  Partial<PropsRange>,
  'mode' | 'selected' | 'onSelect'
> &
  Omit<PropsBase, 'mode' | 'selected' | 'disabled'> & {
    value: DateRange | undefined;
    month: Date;
    onMonthChange: (month: Date) => void;
    onSelect: NonNullable<PropsRange['onSelect']>;
    numberOfMonths: number;
    minDate?: Date;
    maxDate?: Date;
    maxDays?: number;
    minDays?: number;
    autoFocus?: boolean;
    disabledMatchers: Matcher[];
    components?: PropsBase['components'];
  };

export function DateRangeCalendar({
  value,
  month,
  onMonthChange,
  onSelect,
  numberOfMonths,
  minDate,
  maxDate,
  maxDays,
  minDays,
  autoFocus,
  disabledMatchers,
  components,
  ...dayPickerProps
}: DateRangeCalendarProps) {
  return (
    <Calendar
      mode="range"
      selected={value}
      month={month}
      onMonthChange={onMonthChange}
      onSelect={onSelect}
      numberOfMonths={numberOfMonths}
      startMonth={minDate}
      endMonth={maxDate}
      max={maxDays}
      min={minDays}
      autoFocus={autoFocus}
      disabled={disabledMatchers}
      components={components}
      className="p-5"
      {...dayPickerProps}
    />
  );
}
